import { render, staticRenderFns } from "./bases.vue?vue&type=template&id=6caca38e&scoped=true&"
import script from "./bases.vue?vue&type=script&lang=js&"
export * from "./bases.vue?vue&type=script&lang=js&"
import style0 from "./bases.vue?vue&type=style&index=0&id=6caca38e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caca38e",
  null
  
)

export default component.exports